import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'
import StaticQuestionSlide from '../../slides/StaticQuestionSlide'
import Icon from '../../misc/Icons'
import { getQuestionBodyLabel } from '../../../utils/getQuestionBodyLabel'
import { formatDate } from '../../../utils/formatDate'

// Width used for the slide thumbnail. 1.6:1 aspect — RichStaticSlide scales
// itself from the 1280px native width to whatever slideWidth we ask for.
// Keep this below the column's inner width (440 - 2*16 padding = 408px) so
// the slide never forces the flex column wider than its fixed basis.
const PREVIEW_SLIDE_WIDTH = 380
// RichStaticSlide visually scales via `transform: scale()`, but the
// underlying .slide box keeps its native 1280x800 layout size. Without an
// explicit height on the wrapper the slide would push the preview column
// to ~830px tall and force the entire dropdown taller whenever a question
// is highlighted. Same trick QuestionSlideCarousel / SlideGrid use.
const PREVIEW_SLIDE_HEIGHT = Math.round(PREVIEW_SLIDE_WIDTH / 1.6)

function SearchPreviewQuestion({ hit, storeQuestion }) {
  // Prefer the live Redux entity (carries bodyHtml + measurements). Fall back
  // to the hit document — which always has plain `body` but may lack bodyHtml.
  const question = storeQuestion || hit

  const editedAt = (question && question.clientModified) || (hit && hit.clientModified)

  return (
    <div className='searchPreviewPane-body searchPreviewQuestion'>
      {/*
        The slide is the only content here, so let it claim the available
        vertical space and center the slide inside it. Without this wrapper
        the slide sticks to the top of the pane and any extra column height
        becomes one big empty gap above the meta footer.
      */}
      <div className='searchPreviewQuestion-slideWrapper'>
        <div
          className='searchPreviewQuestion-slide'
          style={{ width: PREVIEW_SLIDE_WIDTH, height: PREVIEW_SLIDE_HEIGHT }}
        >
          {question && question.bodyHtml ? (
            <StaticQuestionSlide
              question={question}
              stage='ask'
              mode='view'
              displayWidth={PREVIEW_SLIDE_WIDTH - 2}
              previewCard
            />
          ) : (
            <div className='searchPreviewQuestion-fallback'>
              <Icon name='search-question' />
              <div className='searchPreviewQuestion-fallback-body'>
                {getQuestionBodyLabel(question || { body: '' })}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-meta'>
        <span className='searchPreviewPane-meta-kind'>Question</span>
        {editedAt && (
          <span className='searchPreviewPane-meta-edited'>
            {'Edited '}
            {formatDate(editedAt)}
          </span>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  return {
    storeQuestion: id ? find(state.questions, { id }) : null,
  }
}

export default connect(mapStateToProps)(SearchPreviewQuestion)
